/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, CircularProgress, FormControl, Grid, InputAdornment, InputLabel, OutlinedInput, styled, TextField, Typography } from "@mui/material";
import { ArchitecturalCode, Responsibility } from "../../../common/const";
import { useState } from "react";
import { apiRequest } from "../../../common/common";
import { showNotification } from "../../../common/Notification/ToastifyNotification";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const DemoTypo = styled(Typography)(({ theme }) => ({
    fontSize: 13
}));

export default function ProductDetails({
    selectedProduct,
    item,
    setItem,
    templateItem
}) {
    const productData = selectedProduct[0];
    const { user } = useSelector((state) => state.users);
    const [vendorData, setVendorData] = useState([]);
    const [vendorPage, setVendorPage] = useState(1);
    const [isVendorAvailable, setIsVendorAvailable] = useState(true);
    const [vendorLoading, setVendorLoading] = useState(false);

    const getVendorData = async (pageNo, searchText) => {
        try {
            setVendorLoading(true);
            const response = await apiRequest('get', `/product-provider?type=vender&pageNo=${pageNo}&pageSize=100&${searchText ? `searchText=${searchText}` : ''}`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsVendorAvailable(true);
                const array = [...vendorData, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setVendorData(uniqueArray);
                setVendorLoading(false);
            } else {
                setIsVendorAvailable(false);
                setVendorLoading(false);
            }
        } catch (error) {
            setVendorLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        getVendorData(vendorPage);
    }, []);

    const loadNextVendor = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = vendorPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isVendorAvailable) {
            setVendorPage(numberOfPages);
            await getVendorData(numberOfPages);
        }
    };

    return (
        <Box style={{ padding: '0px 0px 0px 15px' }}>
            <Typography variant='body1' style={{ fontWeight: 'bold' }}>Product Details</Typography>
            <Typography variant='body2'>Basic product information and product IDs</Typography>
            <Grid container mt={1}>
                <Grid item xs={12} sm={12} md={6} lg={3} style={{ border: '1px solid lightgray', padding: '10px' }}>
                    <center>
                        <img
                            src={productData?.images?.[0]?.sortUrl ? `${process.env.REACT_APP_IMAGEURL}bbn=${productData?.images?.[0]?.sortUrl}&uid=${user?.user_id}` : 'https://dummyimage.com/100x100/000/fff'}
                            style={{ width: 100 }}
                            alt="img"
                        />
                    </center>
                    <Typography variant='body1' style={{ fontWeight: 'bold', margin: '10px 0px' }}>Model Name</Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypo variant="body2">Numeric ID:</DemoTypo>
                        <DemoTypo variant="body2">{`${productData?.is_customer_product ? `C-${productData?.alternate_id}`: `${productData?.category?.["sku_no"] || ''}${productData?.sub_category?.["sku_no"] || ''}-${String(productData?.["numaric_sku"]).padStart(3, '0')}`}`}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypo variant="body2">Alphanumeric ID:</DemoTypo>
                        <DemoTypo variant="body2">{`${productData?.is_customer_product ? `C-${productData?.alternate_id}`: `${productData?.category?.["prefix"] || ''}${productData?.sub_category?.["prefix"] || ''}-${String(productData?.["numaric_sku"]).padStart(3, '0')}`}`}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypo variant="body2">Category:</DemoTypo>
                        <DemoTypo variant="body2">{productData?.category?.name || ''}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypo variant="body2">SubCategory:</DemoTypo>
                        <DemoTypo variant="body2">{productData?.["sub_category"]?.name || ''}</DemoTypo>
                    </Box>
                    <Box display="flex" gap={1}>
                        <DemoTypo variant="body2">Manufacturer:</DemoTypo>
                        <DemoTypo variant="body2">{productData?.manufacturer?.name || ''}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypo variant="body2">Catalog #:</DemoTypo>
                        <DemoTypo variant="body2">{productData?.catalog || ''}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypo variant="body2">Price:</DemoTypo>
                        <DemoTypo variant="body2">{`₹ ${Intl.NumberFormat('en-IN').format(productData?.list_price)}`}</DemoTypo>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={9} style={{ paddingLeft: '10px' }}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} md={6} lg={2}>
                            <FormControl size="small" fullWidth variant="outlined">
                                <InputLabel htmlFor="standard-adornment-password">Quantity</InputLabel>
                                <OutlinedInput
                                    label="Quantity"
                                    id="standard-adornment-password"
                                    type='number'
                                    value={item.quantity || ''}
                                    onChange={(e) => {
                                        setItem((prevData) => ({
                                            ...prevData,
                                            quantity: Number(e.target.value)
                                        }));
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.keyCode === 38 || event.keyCode === 40) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={2}>
                            <FormControl size="small" fullWidth variant="outlined">
                                <InputLabel htmlFor="standard-adornment-password">Item Price</InputLabel>
                                <OutlinedInput
                                    label="Item Price"
                                    id="standard-adornment-password"
                                    type='number'
                                    value={item?.list_price || ''}
                                    disabled={templateItem?.department?.type === 'public'}
                                    startAdornment={<InputAdornment position="start">₹</InputAdornment>}
                                    onChange={(e) => {
                                        setItem((prevData) => ({
                                            ...prevData,
                                            list_price: Number(e.target.value),
                                        }));
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.keyCode === 38 || event.keyCode === 40) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                            <Autocomplete
                                value={Responsibility.find((c) => c.value === item?.furnish_responsibility) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={Responsibility}
                                disabled={templateItem?.department?.type === 'public'}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,
                                        furnish_responsibility: newValue?.value || null,
                                    }));
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} label="Furnish Responsibility" name="Furnish Responsibility" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                            <Autocomplete
                                value={Responsibility.find((c) => c.value === item?.install_responsibility) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={Responsibility}
                                disabled={templateItem?.department?.type === 'public'}
                                getOptionLabel={(option) => option?.name}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,
                                        install_responsibility: newValue?.value || null,
                                    }));
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} label="Install Responsibility" name="Install Responsibility" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                            <Autocomplete
                                value={ArchitecturalCode.find((c) => c.value === item?.architectural_code) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={ArchitecturalCode}
                                getOptionLabel={(option) => option?.name}
                                disabled={templateItem?.department?.type === 'public'}
                                getOptionDisabled={(option) => ['8', '9', '10'].includes(option.value)}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,                                        
                                        architectural_code: newValue?.value || null
                                    }));
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} label="Architectural Code" name="Architectural Code" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                            <Autocomplete
                                value={vendorData.find((c) => c.product_provider_id === item?.vendor_id) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={vendorData}
                                disabled={templateItem?.department?.type === 'public'}
                                getOptionLabel={(option) => option?.name}
                                ListboxProps={{
                                    onScroll: (event) => loadNextVendor(event),
                                }}
                                onChange={(event, newValue) => {
                                    setItem((prevData) => ({
                                        ...prevData,
                                        vendor_id: newValue?.product_provider_id || null
                                    }));
                                }}
                                onInputChange={(e) => {
                                    if (e) {
                                        if (e?.target?.value?.length >= 1) {
                                            setVendorData([]);
                                            setVendorPage(1);
                                            getVendorData(1, e?.target?.value);
                                        }
                                    }
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        fullWidth
                                        {...params}
                                        label="Vendor"
                                        name="Vendor"
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {vendorLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }}
                                    />}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}